<template>
    <div class="management">

    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="less" scoped>
.management{
    width: 100%;
    min-height: 100vh;
    background-color: #fff;
}
</style>